import { useQuery } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { kioskConfigurationHttp } from "./kiosk-configuration-http";
import { KioskConfiguration } from "../models/kiosk-configuration";

export const kioskConfigurationsCacheKeys = {
  kioskConfigurations: "kioskConfigurations",
};

export const useListKioskConfigurations = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery<KioskConfiguration[], any>(
    [kioskConfigurationsCacheKeys.kioskConfigurations, organizationKeyName],
    () => kioskConfigurationHttp.getKioskConfigurations(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};
